<ta-lcl-auth-container>
  <ng-container *ngIf="!expired; else expiredLinkNotice">
    <ta-flexbox
      justifyContent="center"
      alignItems="center"
      class="w--100 pb--5"
    >
      <h3 class="heading--3">Reset your password</h3>
    </ta-flexbox>

    <div class="pb--3">
      <ta-form-field
        label="Email"
        [errors]="validationResult?.errors?.nested?.email"
        [forceShowErrors]="forceShowErrors"
        [dirty]="resetForm.get('email')?.dirty"
      >
        <ta-input
          type="email"
          [formControl]="resetForm.get('email')"
        ></ta-input>
      </ta-form-field>
    </div>

    <div class="pb--3">
      <ta-form-field
        label="Password"
        [errors]="validationResult?.errors?.nested?.password"
        [forceShowErrors]="forceShowErrors"
        [dirty]="resetForm.get('password')?.dirty"
        class="pb--3"
      >
        <ta-input
          type="password"
          [formControl]="resetForm.get('password')"
        ></ta-input>
      </ta-form-field>
    </div>

    <div class="pb--3">
      <ta-form-field
        label="Confirm Password"
        [errors]="validationResult?.errors?.nested?.passwordConfirm"
        [forceShowErrors]="forceShowErrors"
        [dirty]="resetForm.get('passwordConfirm')?.dirty"
      >
        <ta-input
          type="password"
          [formControl]="resetForm.get('passwordConfirm')"
        ></ta-input>
      </ta-form-field>
    </div>

    <div [ngClass]="recaptchaWrapperClass">
      <ta-form-field
        [forceShowErrors]="forceShowErrors"
        [errors]="validationResult?.errors?.nested?.recaptchaResponse"
      >
        <ta-recaptcha
          (resolved)="setRecaptchaResponse($event)"
          (visible)="setRecaptchaWrapperClass($event)"
        ></ta-recaptcha>
      </ta-form-field>
    </div>

    <div class="pt--2 pb--4">
      <ta-button
        full
        priority="primary"
        type="submit"
        (taInteract)="submitForm()"
        [disabled]="loading"
      >
        <ng-container *ngIf="!loading"> Change Password </ng-container>
        <ng-container *ngIf="loading">
          Changing Password <ta-icon icon="spinner" spin></ta-icon>
        </ng-container>
      </ta-button>
    </div>
  </ng-container>

  <ta-flexbox
    justifyContent="space-between"
    alignItems="center"
    class="pv--2 w--100"
  >
    <ta-link
      routerLink="/login"
      [queryParams]="{ email: resetForm.value.email, method: 'tapad' }"
      [class.disabled]="loading"
    >
      <ta-icon icon="left-big"></ta-icon>Back to login
    </ta-link>
    <ta-link
      routerLink="/forgot-password"
      [queryParams]="{ email: resetForm.value.email }"
      [class.disabled]="loading"
      >Resend Email</ta-link
    >
  </ta-flexbox>
</ta-lcl-auth-container>

<ng-template #expiredLinkNotice>
  <div class="form-group">
    <div class="header">Reset link has expired</div>
    <p class="text-color-placeholder">
      The password reset link has expired. If you still need to reset your
      password, please request a new email.
    </p>
  </div>
</ng-template>
